/* Cartes produit Maison Aurore (PLP, carrousels, cross-sell) — favoris localStorage + quick-add.
   Délégation d'événements sur document -> couvre les cartes présentes ET ajoutées via PLP load-more.
   Chargé UNE fois (scripts.liquid) au lieu d'être inliné par carte. */
(function () {
  if (window.__maCardInit) return;
  window.__maCardInit = true;

  var FAV_KEY = 'ma:favs';
  function getFavs() {
    try { return JSON.parse(localStorage.getItem(FAV_KEY)) || []; } catch (e) { return []; }
  }
  function paintFavs() {
    var favs = getFavs();
    document.querySelectorAll('[data-fav]').forEach(function (b) {
      b.setAttribute('aria-pressed', favs.indexOf(b.getAttribute('data-fav')) > -1 ? 'true' : 'false');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', paintFavs);
  else paintFavs();
  document.addEventListener('plp:appended', paintFavs);

  document.addEventListener('click', function (e) {
    var fav = e.target.closest('[data-fav]');
    if (fav) {
      var h = fav.getAttribute('data-fav');
      var favs = getFavs();
      var i = favs.indexOf(h);
      if (i > -1) favs.splice(i, 1); else favs.push(h);
      try { localStorage.setItem(FAV_KEY, JSON.stringify(favs)); } catch (err) { /* quota */ }
      fav.setAttribute('aria-pressed', i > -1 ? 'false' : 'true');
      return;
    }

    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');
    btn.disabled = true;

    var sections = [];
    var drawer = document.querySelector('cart-drawer');
    if (drawer && drawer.dataset.sectionId) sections.push(drawer.dataset.sectionId);

    var addUrl = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js';
    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(btn.getAttribute('data-quick-add')), quantity: 1 }],
        sections: sections.join(',')
      })
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw new Error(data.description || 'Add to cart failed');
        return fetch('/cart.js').then(function (r) { return r.json(); }).catch(function () { return null; }).then(function (cart) {
          document.dispatchEvent(new CustomEvent('cart:updated', {
            bubbles: true,
            detail: { resource: {}, data: { source: 'ma-product-card', itemCount: cart ? cart.item_count : undefined, sections: data.sections } }
          }));
          document.dispatchEvent(new CustomEvent('cart:open'));
        });
      });
    }).catch(function (err) {
      console.error('[ma-product-card] quick add:', err);
      document.dispatchEvent(new CustomEvent('toast:open', {
        detail: { type: 'error', message: "We couldn't add this to your basket. Please try again." }
      }));
    }).finally(function () {
      btn.classList.remove('is-loading');
      btn.disabled = false;
    });
  });
})();
